import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MatSnackBar } from '@angular/material';
import { AviationEventsService } from '../../shared/services/aviation-events.service';
var EditEventFeaturesComponent = /** @class */ (function () {
    function EditEventFeaturesComponent(_matDialogRef, data, _aviationEventsService, _fb, _snackBar) {
        this._matDialogRef = _matDialogRef;
        this._aviationEventsService = _aviationEventsService;
        this._fb = _fb;
        this._snackBar = _snackBar;
        this.isLoading = true;
        this.aviationEvent = data.aviationEvent;
    }
    EditEventFeaturesComponent.prototype.ngOnInit = function () {
        var _this = this;
        this._matDialogRef.backdropClick().subscribe(function () {
            _this._matDialogRef.close(null);
        });
        var isValidated = this.aviationEvent.isValidated;
        var isFeatured = this.aviationEvent.isFeatured ? this.aviationEvent.isFeatured : false;
        var hasAopaPresence = this.aviationEvent.hasAopaPresence ? this.aviationEvent.hasAopaPresence : false;
        var isAopaHosted = this.aviationEvent.isAopaHosted ? this.aviationEvent.isAopaHosted : false;
        this.formGroup = this._fb.group({
            isValidated: [this.aviationEvent.isValidated, Validators.nullValidator],
            isFeatured: [this.aviationEvent.isFeatured, Validators.nullValidator],
            hasAopaPresence: [this.aviationEvent.hasAopaPresence, Validators.nullValidator],
            isAopaHosted: [this.aviationEvent.isAopaHosted, Validators.nullValidator]
        }, { updateOn: 'submit' });
        this.isLoading = false;
    };
    EditEventFeaturesComponent.prototype.close = function (result) {
        if (result === void 0) { result = { cancelBtnClicked: true, success: false }; }
        if (result) {
            this._matDialogRef.close(result);
        }
    };
    EditEventFeaturesComponent.prototype.cancel = function () {
        this._matDialogRef.close(null);
    };
    EditEventFeaturesComponent.prototype.save = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var TEMP_aviationEvent, e_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        TEMP_aviationEvent = this.aviationEvent;
                        if (this.formGroup.invalid) {
                            this._snackBar.open('Form field validation failed. check form values', null, { duration: 5000 });
                            return [2 /*return*/];
                        }
                        this.aviationEvent.isValidated = this.formGroup.value.isValidated || false;
                        this.aviationEvent.isFeatured = this.formGroup.value.isFeatured || false;
                        this.aviationEvent.hasAopaPresence = this.formGroup.value.hasAopaPresence || false;
                        this.aviationEvent.isAopaHosted = this.formGroup.value.isAopaHosted || false;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this._aviationEventsService.updateAviationEvent(this.aviationEvent)];
                    case 2:
                        _a.sent();
                        this.close({ cancelBtnClicked: false, success: true });
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        this.aviationEvent = TEMP_aviationEvent;
                        this.close({ cancelBtnClicked: false, success: false });
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    return EditEventFeaturesComponent;
}());
export { EditEventFeaturesComponent };
